<template>
  <div>
    <v-card v-if="notFound" flat>
      <v-card-text>
        <v-card-text>
          <div class="text-center title">This link is expire.</div>
        </v-card-text>
      </v-card-text>
    </v-card>
    <div v-if="!infoCollected">


      <v-container grid-list-lg fill-height fluid>
        <v-layout align-center justify-center fill-height>
          <v-flex shrink>
            <v-card v-if="!infoCollected" outlined max-width="800">
              <v-stepper vertical v-model="step" class="elevation-0">
                <v-stepper-step :complete="step > 1" step="1">
                  Parents Information
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field autofocus outlined dense :error-messages="fatherNameErrors"
                          :background-color="`${Lead.fatherName ? false : '#E8F5E9'}`"
                          :hide-details="fatherNameErrors.length === 0" v-model="Lead.fatherName" label="Father's Name">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field type="tel" outlined dense v-mask="'(###) ###-####'"
                          :background-color="`${Lead.fatherPhoneNumber ? false : '#E8F5E9'}`"
                          :error-messages="fatherPhoneNumberErrors" :hide-details="fatherPhoneNumberErrors.length === 0"
                          v-model="Lead.fatherPhoneNumber" label="Father's Primary Number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field outlined dense :error-messages="fatherEmailAddressErrors"
                          :background-color="`${Lead.fatherEmailAddress ? false : '#E8F5E9'}`" :hide-details="fatherEmailAddressErrors.length === 0
                            " @change="fixFatherEmail" v-model="Lead.fatherEmailAddress" label="Father's Email">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field outlined dense hide-details v-model="Lead.motherName" label="Mother's Name">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field outlined dense hide-details v-mask="'(###) ###-####'" type="tel"
                          v-model="Lead.motherPhoneNumber" label="Mother's Primary Number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field outlined dense :error-messages="motherEmailAddressErrors" :hide-details="motherEmailAddressErrors.length === 0
                          " @change="fixMotherEmail" v-model="Lead.motherEmailAddress" label="Mother's Email">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="nameDone" color="primary" large="large">Next</v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="step > 2" step="2">
                  Address
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-col cols="12" sm="12">
                        <v-text-field outlined :error-messages="addressErrors"
                          :background-color="`${Address.address ? false : '#E8F5E9'}`"
                          :hide-details="addressErrors.length === 0" dense v-model="Address.address" label="Address">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined :error-messages="cityErrors" :hide-details="cityErrors.length === 0"
                          :background-color="`${Address.city ? false : '#E8F5E9'}`" dense
                          @change="Address.city = properCase(Address.city)" v-model="Address.city" label="City">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined dense v-mask="'AA'" :error-messages="stateErrors"
                          :background-color="`${Address.state ? false : '#E8F5E9'}`"
                          :hide-details="stateErrors.length === 0" v-model="Address.state" label="State">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined dense v-mask="'#####'" :error-messages="zipErrors"
                          :background-color="`${Address.zip ? false : '#E8F5E9'}`" :hide-details="zipErrors.length === 0"
                          v-model="Address.zip" label="Zip Code">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn large text @click="step = step - 1">Back</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="addressDone" color="primary" large>next</v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="step > 3" step="3">
                  Emergency Contact
                </v-stepper-step>
                <v-stepper-content step="3">
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined dense :error-messages="emergencyNameErrors"
                          :background-color="`${Emergency.emergencyName ? false : '#E8F5E9'}`"
                          :hide-details="emergencyNameErrors.length === 0" v-model="Emergency.emergencyName"
                          label="Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined dense v-mask="'(###) ###-####'" type="tel"
                          :background-color="`${Emergency.emergencyPhoneNumber ? false : '#E8F5E9'}`"
                          :error-messages="emergencyPhoneNumberErrors" :hide-details="emergencyPhoneNumberErrors.length === 0
                            " v-model="Emergency.emergencyPhoneNumber" label="Phone Number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field outlined :error-messages="emergencyRelationErrors"
                          :background-color="`${Emergency.emergencyRelation ? false : '#E8F5E9'}`"
                          :hide-details="emergencyRelationErrors.length === 0" dense v-model="Emergency.emergencyRelation"
                          label="Relation"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn large text @click="step = step - 1">Back</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="emergencyDone" color="primary" large>next</v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <v-stepper-step :complete="step > 4" step="4">
                  Student & Classes
                </v-stepper-step>

                <v-stepper-content step="4">
                  <v-row align="center">
                    <v-col>Add New Student</v-col>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                      <v-dialog v-model="dialog" persistent width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn outlined rounded raised small v-bind="attrs" v-on="on">
                            <v-icon small>add</v-icon> New
                          </v-btn>
                        </template>

                        <v-card>
                          <ModelTitle title="Add Student" @close="closeDialog" />

                          <v-card-text>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field outlined dense
                                  :background-color="`${Student.firstName ? false : '#E8F5E9'}`"
                                  :error-messages="studentFirstNameErrors" :hide-details="studentFirstNameErrors.length === 0
                                    " autofocus v-model="Student.firstName" label="First Name"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field outlined :background-color="`${Student.lastName ? false : '#E8F5E9'}`"
                                  :error-messages="studentLastNameErrors" :hide-details="studentLastNameErrors.length === 0
                                    " dense v-model="Student.lastName" label="Last Name"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-select dense :background-color="`${Student.gender ? false : '#E8F5E9'}`"
                                  :error-messages="genderErrors" :hide-details="genderErrors.length === 0"
                                  :items="['male', 'female']" label="Gender" v-model="Student.gender" outlined>
                                </v-select>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field outlined dense :background-color="`${Student.dob ? false : '#E8F5E9'}`"
                                  :error-messages="dobError" :hide-details="dobError.length === 0" type="date"
                                  v-model="Student.dob" label="Date of Birth"></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-autocomplete dense :items="Classes"
                                  :background-color="`${Student.selectedClass ? false : '#E8F5E9'}`" clearable
                                  item-text="name" :error-messages="classIdErrors"
                                  :hide-details="classIdErrors.length === 0" v-model="Student.selectedClass" return-object
                                  label="Select Department" outlined>
                                  <template slot="item" slot-scope="{ item }">
                                    <span>{{ item.name }}</span>
                                    <v-spacer></v-spacer>
                                    <span>{{
                                      item.defaultFee | currency
                                    }}</span>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <v-card-text>
                            <div class="text-center">
                              {{ Student.firstName }} {{ Student.lastName }}
                              <span v-if="Student.dob">is {{ getAge(Student.dob) }} year old</span>
                            </div>
                            <div v-if="getAge(Student.dob) < 5" class="red--text text-center">
                              Minimum age of admission is 6 year
                            </div>
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-btn color="primary" :disabled="getAge(Student.dob) > 4 ? false : true
                              " block @click="addStudent">
                              Add student
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-data-table :headers="headers" :items="Students" :items-per-page="10" class="elevation-0"
                      hide-default-footer>
                      <template v-slot:no-data>
                        <div class="text-center my-3">No Students</div>
                        <v-btn color="primary" @click="dialog = true">
                          Add First Student
                        </v-btn>
                      </template>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.firstName }} {{ item.lastName }}</td>
                          <td>{{ item.dob | moment('L') }}</td>
                          <td>{{ item.selectedClass.name }}</td>
                          <td>
                            <v-icon @click="deleteItem(item)">
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </template>
                      <!-- <template v-slot:item.actions="{ item }">
                        <v-icon @click="deleteItem(item)">
                          mdi-delete
                        </v-icon>
                      </template> -->
                    </v-data-table>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn large text @click="step = step - 1">Back</v-btn>
                    <v-spacer></v-spacer>
                    <!-- <v-btn @click="studentDone" v-if="takeCard" color="primary" large>next</v-btn> -->
                    <v-btn @click="submitWithOutCard" :loading="loading" color="primary" large>Submit</v-btn>
                  </v-card-actions>
                </v-stepper-content>

                <!-- <v-stepper-step :complete="step > 5" step="5" v-if="takeCard">
                  Confirmation
                </v-stepper-step>

                <v-stepper-content step="5" v-if="takeCard" class="pl-0 pr-10 ml-2">
                  <div class="my-3 text-center">
                    Your card will not be charge until student start the
                    classes
                  </div>
                  <v-card v-if="StripeKey" max-width="400" class="centerdiv" flat>
                    <v-card outlined>
                      <v-card-text>
                        <card ref="card" class="stripe-card" :class="{ complete }" :stripe="StripeKey"
                          @change="complete = $event.complete" />
                      </v-card-text>
                    </v-card>
                    <v-img class="text-center" src="@/assets/images/stripeimg.jpg" />
                  </v-card>
                  <div v-if="Business" class="text-center mt-5">
                    By pressing submit button you have agree to all
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" @click="openTermBox = true" v-on="on">
                          terms and conditions
                        </a>
                      </template>
                      Opens in new window
                    </v-tooltip>
                    of {{ Business.name }}
                  </div>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn large text @click="step = step - 1">Back</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="submit" :loading="loading" color="primary" large>Submit</v-btn>
                  </v-card-actions>
                </v-stepper-content> -->
              </v-stepper>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div v-else>
      <v-card-text>
        <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation" />
        <div class="text-center">
          <div class="text-h5">All Set</div>
          <div class="mt-3">We will contact you soon insh Allah.</div>
        </div>
      </v-card-text>
    </div>
    <v-dialog v-model="openTermBox">
      <v-card v-if="Business">
        <ModelTitle title="Terms & Conditions" @close="openTermBox = false" />

        <v-card-text>
          <v-textarea hide-details readonly auto-grow v-model="Business.policy"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="openTermBox = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-card-actions>
      <div class="text-center">
        Power by: <span>taleem.app</span> -
        <span class="caption">{{ version }}</span>
      </div>
    </v-card-actions> -->
    <v-footer class="padless" app>
      <v-col class="text-center pa-0" cols="12">
        {{ version }} — <span>Power by: </span><strong>taleem.app</strong>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
// import { Card, createToken } from "vue-stripe-elements-plus";
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");
import Lottie from "@/components/lottie.vue";
import GlobalFunction from "@/mixins/GlobalFunction";
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");


export default {
  name: "application-page",
  props: ['currentBusiness', 'takeCard'],
  data() {
    return {
      step: 1,
      infoCollected: false,
      openTermBox: false,
      loading: false,
      Business: null,
      StripeKey: null,
      notFound: false,
      dialog: false,
      complete: false,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "firstName",
        },
        { text: "DOB", value: "dob", sortable: false },
        { text: "Class", value: "selectedClass.name", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
      Lead: {
        fatherName: null,
        fatherPhoneNumber: null,
        fatherEmailAddress: null,
        motherName: null,
        motherPhoneNumber: null,
        motherEmailAddress: null,
      },
      Address: {
        address: null,
        city: null,
        state: "NY",
        zip: null,
      },
      Emergency: {
        emergencyName: null,
        emergencyPhoneNumber: null,
        emergencyRelation: null,
      },
      Student: {
        firstName: null,
        lastName: null,
        dob: null,
        selectedClass: null,
        ClassId: null,
      },
      Students: [],
      Classes: [],
      selectedClass: null,
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Lead: {
      fatherName: {
        required,
      },
      fatherPhoneNumber: {
        required,
      },
      fatherEmailAddress: {
        required,
        email,
      },
      motherEmailAddress: {
        email,
      },
    },
    Emergency: {
      emergencyName: {
        required,
      },
      emergencyPhoneNumber: {
        required,
      },
      emergencyRelation: {
        required,
      },
    },
    Address: {
      address: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      zip: {
        required,
      },
    },
    Student: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      dob: {
        required,
      },
      gender: {
        required,
      },
      selectedClass: {
        required,
      },
    },
  },
  computed: {
    version() {
      return pjson.version;
    },
    studentFirstNameErrors() {
      const errors = [];
      if (!this.$v.Student.firstName.$dirty) return errors;
      if (!this.$v.Student.firstName.required)
        errors.push("First Name is required");
      return errors;
    },
    studentLastNameErrors() {
      const errors = [];
      if (!this.$v.Student.lastName.$dirty) return errors;
      if (!this.$v.Student.lastName.required)
        errors.push("Last Name is required");
      return errors;
    },
    dobError() {
      const errors = [];
      if (!this.$v.Student.dob.$dirty) return errors;
      if (!this.$v.Student.dob.required)
        errors.push("Date of birth is required");
      return errors;
    },
    classIdErrors() {
      const errors = [];
      if (!this.$v.Student.selectedClass.$dirty) return errors;
      if (!this.$v.Student.selectedClass.required)
        errors.push("Class is required");
      // if (!this.$v.Product.selectedClass.minValue) errors.push("Please Select Department");

      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.Student.gender.$dirty) return errors;
      if (!this.$v.Student.gender.required) errors.push("Gender is required");

      return errors;
    },
    fatherNameErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherName.$dirty) return errors;
      if (!this.$v.Lead.fatherName.required) errors.push("Name is required");
      return errors;
    },
    fatherPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherPhoneNumber.$dirty) return errors;
      if (!this.$v.Lead.fatherPhoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    fatherEmailAddressErrors() {
      const errors = [];
      if (!this.$v.Lead.fatherEmailAddress.$dirty) return errors;
      if (!this.$v.Lead.fatherEmailAddress.required)
        errors.push("Email Address is required");
      if (!this.$v.Lead.fatherEmailAddress.email)
        errors.push("Email is not valid");
      return errors;
    },
    motherEmailAddressErrors() {
      const errors = [];
      if (!this.$v.Lead.motherEmailAddress.$dirty) return errors;
      if (!this.$v.Lead.motherEmailAddress.email)
        errors.push("Email is not valid");
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.Address.address.$dirty) return errors;
      if (!this.$v.Address.address.required) errors.push("Address is required");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.Address.city.$dirty) return errors;
      if (!this.$v.Address.city.required) errors.push("City is required");
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.$v.Address.state.$dirty) return errors;
      if (!this.$v.Address.state.required) errors.push("State is required");
      return errors;
    },
    zipErrors() {
      const errors = [];
      if (!this.$v.Address.zip.$dirty) return errors;
      if (!this.$v.Address.zip.required) errors.push("Zip Code is required");
      return errors;
    },
    emergencyNameErrors() {
      const errors = [];
      if (!this.$v.Emergency.emergencyName.$dirty) return errors;
      if (!this.$v.Emergency.emergencyName.required)
        errors.push("Name is required");
      return errors;
    },
    emergencyPhoneNumberErrors() {
      const errors = [];
      if (!this.$v.Emergency.emergencyPhoneNumber.$dirty) return errors;
      if (!this.$v.Emergency.emergencyPhoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    emergencyRelationErrors() {
      const errors = [];
      if (!this.$v.Emergency.emergencyRelation.$dirty) return errors;
      if (!this.$v.Emergency.emergencyRelation.required)
        errors.push("Relation is required");
      return errors;
    },
  },
  components: {
    Lottie,
  },
  created() {
    // let a = "(718) 299-2222";

    // let st = a.replace(/[^a-zA-Z0-9]/g, "");

    // console.log("test test", st);
    // this.loadBusiness();
    this.Business = this.currentBusiness
  },
  watch: {
    currentBusiness(val) {
      this.StripeKey = val.metadata.publicStripeId;
      this.Classes = val.Classes;
    }
  },
  methods: {
    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    nameDone() {
      this.$v.Lead.$touch();
      if (this.$v.Lead.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.step = 2;
      }
    },
    addressDone() {
      this.$v.Address.$touch();
      if (this.$v.Address.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.step = 3;
      }
    },
    emergencyDone() {
      this.$v.Emergency.$touch();
      if (this.$v.Emergency.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.step = 4;
      }
    },
    studentDone() {
      if (this.Students.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Please add student",
          });
      } else {
        this.step = 5;
      }
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    closeDialog() {
      this.emptyDialog();
      this.$v.Student.$reset();
      this.dialog = false;
    },
    emptyDialog() {
      this.Student = {
        firstName: null,
        lastName: null,
        dob: null,
        selectedClass: null,
      };
    },
    fixFatherEmail() {
      this.Lead.fatherEmailAddress = this.Lead.fatherEmailAddress
        .toLowerCase()
        .trim();
    },
    fixMotherEmail() {
      this.Lead.motherEmailAddress = this.Lead.motherEmailAddress
        .toLowerCase()
        .trim();
    },
    loadBusiness() {
      let id = this.$route.params.id;
      console.log("id", id);
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("response", response);
          this.Business = response.data;
          this.StripeKey = this.Business.metadata.publicStripeId;
          this.Classes = this.Business.Classes;
        })
        .catch((error) => {
          console.log("error", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    addStudent() {
      this.$v.Student.$touch();
      if (this.$v.Student.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.Student.ClassId = this.Student.selectedClass.id
        this.Students.push(this.Student);
        this.closeDialog();
      }
    },
    deleteItem(item) {
      this.Students.splice(this.Students.indexOf(item), 1);
      // this.editedIndex = this.Students.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialogDelete = true
    },
    submitWithOutCard() {
      console.log('submitWithOutCard')
      if (this.Students.length === 0) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Please add student",
          });
      } else {
        this.submit()
      }
    },
    async submit() {
      this.$v.Lead.$touch();
      if (this.$v.Lead.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.Students.length === 0) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
            })
            .fire({
              icon: "error",
              title: "Please Enter Student",
            });
          this.loading = false;
          this.dialog = true;
        }
        try {
          this.loading = true;
          //  this.Lead.students = this.Students;
          //   this.Lead = {
          //     ...this.Lead,
          //     ...this.Emergency,
          //     ...this.Address,
          //   }
          //   console.log('lead', this.Lead)
          this.Lead.students = this.Students;
          this.Lead.status = "Open"
          this.Lead = {
            ...this.Lead,
            ...this.Emergency,
            ...this.Address,
          }



          // if (this.takeCard) {
          //   let data = {};
          //   // data = await createToken();
          //   // console.log('token data', data)
          //   if (data.error) {
          //     console.log("error adding card", data);
          //     this.$swal
          //       .mixin({
          //         toast: true,
          //         position: "top-end",
          //         showConfirmButton: false,
          //         timer: 3000,
          //       })
          //       .fire({
          //         icon: "error",
          //         title: data.error.message,
          //       });
          //     this.loading = false;
          //     return false
          //   }
          //   // this.Lead.token = data.token
          // }



          if (this.Lead.fatherPhoneNumber) {
            this.Lead.fatherPhoneNumber = this.Lead.fatherPhoneNumber.replace(
              /[^a-zA-Z0-9]/g,
              ""
            );
          }

          if (this.Lead.motherPhoneNumber) {
            this.Lead.motherPhoneNumber = this.Lead.motherPhoneNumber.replace(
              /[^a-zA-Z0-9]/g,
              ""
            );
          }

          if (this.Lead.emergencyPhoneNumber) {
            this.Lead.emergencyPhoneNumber =
              this.Lead.emergencyPhoneNumber.replace(/[^a-zA-Z0-9]/g, "");
          }

          console.log("this.Students.length", this.currentBusiness, this.Lead);
          this.loading = true;
          applicationService
            .publicLeadCreate(this.currentBusiness.alias, this.Lead)
            .then(() => {
              // console.log("response", response);
              this.infoCollected = true;
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              console.log("err", err);
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "error",
                  title: err.message,
                });
            });

        } catch (error) {
          this.loading = false;
          console.log("error adding card", error);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: error.message,
            });
        }
      }
    },
  },
};
</script>

<style scoped>
.centerdiv {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}
</style>